import {
  Injectable,
  inject,
  PLATFORM_ID,
  Renderer2,
  RendererFactory2,
} from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SPRITE_CONTENT } from '@rds-nova/icons';

@Injectable({
  providedIn: 'root',
})
export class IconRegistryService {
  private platformId = inject(PLATFORM_ID);
  private document = inject(DOCUMENT);
  private rendererFactory = inject(RendererFactory2);
  private renderer: Renderer2;
  private isInitialized = false;

  constructor() {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  initializeIcons(): void {
    if (this.isInitialized || !isPlatformBrowser(this.platformId)) {
      return;
    }

    // Check if sprite container already exists
    const existingContainer = this.document.querySelector(
      '.nova-icon-sprite-container',
    );
    if (existingContainer) {
      this.isInitialized = true;
      return;
    }

    // Create sprite container using Renderer2
    const spriteContainer = this.renderer.createElement('div');
    this.renderer.addClass(spriteContainer, 'nova-icon-sprite-container');
    this.renderer.setStyle(spriteContainer, 'display', 'none');
    this.renderer.setProperty(spriteContainer, 'innerHTML', SPRITE_CONTENT);

    // Append to document body
    this.renderer.appendChild(this.document.body, spriteContainer);

    this.isInitialized = true;
  }

  isIconRegistryInitialized(): boolean {
    return this.isInitialized;
  }
}
